import React from 'react';

export const InnerWrapper = ({className, children}) => {
    return (
        <div className={className ? className : '' } style={{maxWidth: 400, width: '100%', margin: '0 auto'}}>
            {children}
        </div>
    );
};
